// extracted by mini-css-extract-plugin
module.exports = {"alert":"_2hFtS8Scpal-KnX1bsi26L","support":"_368-7lqA1BfKsgPFHWYzV"};